module.exports = __webpack_public_path__ + "static/media/speakers_logos_coloradoSch.c342a25b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_coloradoSch.jpg
// module id = 265
// module chunks = 0